<template>
  <section class="mb-40">
    <div class="container">
      <h2 class="main-subtitle text-align-center color-darkblue --bold" style="margin-bottom: 27px;">
        {{ title }}
      </h2>
      <div class="customers-rating-wrap" id="customers-rating-wrap">
        <div class="customers-rating__item" style="margin-top: 32px;">
          <img src="/en/img/index-customers-rating1.png" alt="" width="261">
        </div>
        <div class="customers-rating__item">
          <img src="/en/img/index-customers-rating2.png" alt="" width="261">
        </div>
        <div class="customers-rating__item" style="margin-top: 8px;">
          <img src="/en/img/index-customers-rating3.png" alt="" width="258">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "CriticsBlock",
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/blocks/CriticsBlock.vue